import { Category, Document, Workflow } from './types';
import { MultiselectOption } from '../../../types/multiselect';

export const getDocumentsByWorkflow = (
  workflow: string,
  documentsByWorkflowMap: Record<string, Document[]>,
  workflows: Workflow[] = []
): Document[] => {
  if (workflow === 'all') {
    // When getting all documents, add workflow info to each
    const workflowMap = new Map(workflows.map((w) => [w.name, w]));
    return Object.entries(documentsByWorkflowMap).flatMap(([workflowName, docs]) => {
      const workflowInfo = workflowMap.get(workflowName);
      return docs.map((doc) => ({
        ...doc,
        workflow: workflowInfo ? {
          id: workflowInfo.id,
          name: workflowInfo.name,
          displayName: workflowInfo.displayName,
        } : undefined,
      }));
    });
  }

  // For a specific workflow, add workflow info to each document
  const workflowInfo = workflows.find((w) => w.name === workflow);
  const docs = documentsByWorkflowMap[workflow] || [];
  return docs.map((doc) => ({
    ...doc,
    workflow: workflowInfo ? {
      id: workflowInfo.id,
      name: workflowInfo.name,
      displayName: workflowInfo.displayName,
    } : undefined,
  }));
};

export const filterDocumentsBySearch = (
  documents: Document[],
  searchQuery: string
): Document[] => {
  if (!searchQuery.trim()) {
    return documents;
  }
  return documents.filter(
    (doc) => doc.displayName.toLowerCase().includes(searchQuery.toLowerCase())
    || doc.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
};

export const filterDocumentsByCategories = (
  documents: Document[],
  categoryIds: number[]
): Document[] => {
  if (categoryIds.length === 0) {
    return documents;
  }

  return documents.filter(
    (doc) => doc.category && categoryIds.includes(doc.category.id)
  );
};

export const categoriesToOptions = (
  categories: Category[]
): MultiselectOption<Category>[] => categories.map((category) => ({
  value: category,
  label: category.name,
}));
